import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { _single } from "../../../../core/services/dataBean/EntityCatalog";
import { InputDate } from "../../../theme/Input/InputDate";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { HealthID } from "../../../admin/configuracion/HealthID/HealthID";
import { _CIUO88ACAccount } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { HealthIDEditor } from "../../../admin/configuracion/HealthID/HealthIDEditor";


interface Props {
    accountID: number;
}

export const CIUO88ACAccount = ({ accountID }: Props) => {

    const ciuu = useDataBean(_CIUO88ACAccount);
    const single = Singleton.getInstance();
    const [fromDate, setfromDate] = useState<any>(null);
    const [Health, setHealth] = useState<any>(null);
    const [NameSelect, setNameSelect] = useState<any>(null);
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [accountID])

    const getLista = () => {

        ciuu.instance.getCIUO88ACAccountCatalog(accountID,fromDate).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                   //console.log(resp)
                }
            }
        )

    }

    const create = () => {
        ciuu.setBean({
           
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        ciuu.instance.deleteVoid(ciuu.bean.IDVehicle).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const addCIUO88ACAccountCatalog = () => {
        
        ciuu.instance.addCIUO88ACAccountCatalog(accountID,Health,ciuu.bean.FromDate,_single.getAccountID()).then(
            (resp: any) => {
                console.log(resp)
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    
    
    const head = [
        { title: 'ID', property: 'IDCIUO88ACAccount', visible: true },
        { title: 'Fecha Desde', property: 'FromDate', visible: true },
        { title: 'Código Ocupación', property: 'JsonCode', visible: true },
        { title: 'Nombre Ocupación', property: 'Name', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <label>Ocupaciones</label>
            <div className="col-md-4">
                <InputDate name="Fecha Desde" value={fromDate} label="Fecha Apertura" setDate={(e) => setfromDate(e)} />
            </div>
            <div className="col-md-4">
                 <BasicButton icon="" eventClick={getLista}>Buscar</BasicButton>
            </div>
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={ciuu.setBean} iconButtons={iconButtonsItem} listButtons={listaBotones()}></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={addCIUO88ACAccountCatalog}>
                    <div className="row">
                        <div className="col-md-12">
                            <InputDate name="Fecha Desde" value={ciuu.bean.FromDate} label="Fecha Inicio Ocupación" setDate={(e: any) => { ciuu.setBean({ ...ciuu.bean, "FromDate": e }) }} />
                        </div>
                    <div className="col-md-12">
                            <HealthIDEditor render={NameSelect} tipoPresupuesto={29} id={null} edit={true} onSelect={(item) => { console.log(item); setHealth(item);}} onSelectName={(item) => { console.log(item); setNameSelect(item);}}/>
                    </div>
                    </div>
                </Modal>
                
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>
        </div>
    )
}